const departments = {
    leader: 'Vedoucí',
    leaders: 'Vedoucí oddělení',
    led_departments: 'Řízená oddělení',
    edit_leaders: 'Spravovat vedoucí',
    add_leader: 'Přidat',
    remove_leader: 'Odebrat',
    no_leaders: 'Bez vedoucích',
    local: 'Místní správa',
    managed_members: 'Členové ve správě',
    leader_scope_hint: 'Spravujte přiřazení ve svých odděleních a pododděleních.',
    leader_permission_hint: 'Vedoucí spravují přiřazení ve svých odděleních a pododděleních, bez změny rolí nebo hierarchie.',
    primary_synced: 'Hlavní oddělení spravuje Feishu.',
    status_active: 'Aktivní',
    status_suspended: 'Pozastavený',
    status_departed: 'Odešel',
    status_pending: 'Čeká na aktivaci',
    search: 'Hledat',
    previous_page: 'Předchozí stránka',
    next_page: 'Další stránka',
    directory_title: 'Členové organizace',
    member_name: 'Člen',
    search_members: 'Hledat podle jména nebo uživatelského jména',
    include_descendants: 'Zahrnout pododdělení',
    no_members: 'Žádní odpovídající členové.',
    all_members: 'Všichni členové',
    all_departments: 'Všechna oddělení',
    edit_member: 'Upravit oddělení',
    add_child: 'Přidat pododdělení',
    expand_department: 'Rozbalit {{name}}',
    collapse_department: 'Sbalit {{name}}',
    title: 'Oddělení',
    description: 'Spravujte oddělení a přiřazení členů této organizace.',
    create: 'Vytvořit oddělení',
    edit: 'Upravit oddělení',
    name: 'Název oddělení',
    parent: 'Nadřazené oddělení',
    root: 'Bez nadřazeného oddělení',
    id: 'ID oddělení',
    members: 'Oddělení členů',
    member_id: 'Uživatelské ID člena',
    primary: 'Hlavní oddělení',
    none: 'Nenastaveno',
    assignments: 'Přiřazení oddělení',
    no_assignments: 'Zatím žádná přiřazení oddělení.',
    assignment_hint: 'Přiřaďte místní oddělení a volitelně hlavní oddělení. Přiřazení z adresáře jsou jen pro čtení.',
    empty: 'Zatím žádná oddělení.',
    readonly: 'Můžete zobrazit oddělení a svá přiřazení. Změny provádí správce organizace.',
    load_error: 'Data nelze načíst. Zkuste to znovu.',
    mutation_error: 'Uložení se nezdařilo. Zkontrolujte oprávnění, členství a hierarchii oddělení.',
    loading: 'Načítání…',
    synced: 'Spravováno adresářem',
    choose: 'Hledat oddělení',
    organizations_title: 'Organizace a oddělení',
    organizations_description: 'Vyberte organizaci pro zobrazení nebo správu jejích oddělení.',
    no_organizations: 'Nejste členem organizace. Kontaktujte správce.',
    organization: 'Aktuální organizace',
    choose_organization: 'Vyberte organizaci',
    delete_title: 'Smazat oddělení',
    delete_description: 'Smazat „{{name}}“? Nejprve přesuňte členy a podřízená oddělení.',
};
export default Object.freeze(departments);
